<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <b-alert v-if="inactiveSubscription" show class="mb-3" variant="danger">
            <h4>Expired Subscription</h4>
            <p>
              Your subscription has expired. You will not be able to invite new clients until you <b-link to="/subscribe">renew your subscription</b-link>.
            </p>
          </b-alert>

          <page-title title="My Subscription" />
          <hr />

          <b-row v-if="subscriptionUser">
            <b-col>
              <b-card-group class="mt-3">
                <b-card v-if="subscriptionUser">
                  <template v-slot:header>
                    <h2>Subscription Details</h2>
                  </template>
                  <b-form-row>
                    <b-col sm="4" class="form-static-label">Name:</b-col>
                    <b-col sm="8" class="form-static-value">{{subscriptionUser.subscription.displayName}}</b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col sm="4" class="form-static-label">Plan:</b-col>
                    <b-col sm="8" class="form-static-value">{{getSubscriptionName(subscriptionUser.subscription.priceName)}}</b-col>
                  </b-form-row>
                  <b-form-row v-if="subscriptionUser.subscription.stripeStatus != 'canceled'">
                    <b-col sm="4" class="form-static-label">Expiration:</b-col>
                    <b-col sm="8" class="form-static-value">{{subscriptionUser.subscription.stripeExpiration}}</b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col sm="4" class="form-static-label">Status:</b-col>
                    <b-col sm="8" class="form-static-value">{{subscriptionUser.subscription.stripeStatus}}</b-col>
                  </b-form-row>
                  <!-- Shown after the customer cancels: subscription stays active until the end of the paid period -->
                  <b-alert v-if="isCancellationScheduled" show variant="warning" class="mt-3 mb-0">
                    Your subscription has been canceled and will not renew.
                    You will keep full access until <strong>{{formatDate(stripeSubscriptionDetails.currentPeriodEnd)}}</strong>.
                    <div class="mt-2">
                      <!-- Undo the cancellation while still in the paid period; the subscription then renews as normal -->
                      <b-button variant="success" size="sm" :disabled="isResuming" @click="resumeSubscription">
                        {{ isResuming ? 'Resuming...' : 'Keep My Subscription' }}
                      </b-button>
                    </div>
                    <div v-if="resumeError" class="text-danger mt-2">{{resumeError}}</div>
                  </b-alert>
                  <hr />
                  <!-- <div>
                    <b-link v-b-modal="'modalChangePlan'">Change Plan</b-link>
                  </div> -->
                  <!-- Hide "Cancel Subscription" once a cancellation is already scheduled -->
                  <div v-if="subscriptionUser.subscription.stripeStatus != 'canceled' && !isCancellationScheduled">
                    <b-link v-b-modal="'modalCancelSubscription'">Cancel Subscription</b-link>
                  </div>
                  <div v-if="subscriptionUser.subscription.stripeStatus == 'canceled'">
                    <b-button variant="success" to="/subscribe">Renew Subscription</b-button>
                  </div>
                </b-card>
                <b-card v-if="stripeSubscriptionDetails">
                  <template v-slot:header>
                    <h2>Billing Details</h2>
                  </template>
                  <b-form-row>
                    <b-col sm="4" class="form-static-label">Card Number:</b-col>
                    <b-col sm="8" class="form-static-value">ending in {{stripeSubscriptionDetails.last4}}</b-col>
                  </b-form-row>
                  <b-form-row>
                    <b-col sm="4" class="form-static-label">Card Expiration:</b-col>
                    <b-col sm="8" class="form-static-value">{{stripeSubscriptionDetails.expMonth}}/{{stripeSubscriptionDetails.expYear}}</b-col>
                  </b-form-row>
                  <hr />
                  <div>
                    <b-link to="/subscriber/changePaymentMethod">Change Payment Method</b-link>
                  </div>
                </b-card>
              </b-card-group>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modalCancelSubscription" title="Cancel Subscription" ok-title="Yes, cancel my subscription" ok-variant="danger" cancel-title="No, do not cancel my subscription" cancel-variant="success" @ok="cancelSubscription">
      <p>Are you sure you want to cancel your subscription?</p>
      <p v-if="subscriptionUser">
        Your subscription will remain active until {{subscriptionUser.subscription.stripeExpiration}}. After that day, you will be able to view old mitigation
        reports, but you will not be able to invite new clients.
      </p>
    </b-modal>

    <!-- <b-modal id="modalChangePlan" title="Change Plan" ok-title="Never mind, keep my current plan" ok-variant="secondary" ok-only size="lg">
      <p v-if="subscriptionUser">
        If you switch plans, the change will take effect when your subscription next renews, on {{subscriptionUser.subscription.stripeExpiration}}.
      </p>
      <div class="text-center">
        <b-card-group deck class="mb-3 text-center">
          <b-card class="mb-4 shadow-sm">
            <template v-slot:header>
              <h4 class="my-0">Monthly Subscription</h4>
            </template>
            <b-card-body>
              <b-card-title>
                <h1>$39.80 <small class="text-muted">/ month</small></h1>
              </b-card-title>
              <p>The monthly subscription has no long-term commitment and can be canceled at any time.</p>
            </b-card-body>
            <template v-slot:footer>
              <div v-if="subscriptionUser.subscription.priceName == 'StandardMonthly'">Your Current Plan</div>
              <b-button variant="primary" v-if="subscriptionUser.subscription.priceName != 'StandardMonthly'">Switch to Monthly Subscription</b-button>
            </template>
          </b-card>
          <b-card class="mb-4 shadow-sm">
            <template v-slot:header>
              <h4 class="my-0">
                Yearly Subscription
                <b-badge variant="success">Best Deal</b-badge>
              </h4>
            </template>
            <b-card-body>
              <b-card-title>
                <h1>$398.00 <small class="text-muted">/ year</small></h1>
              </b-card-title>
              <p>Save almost $50/year with an annual subscription.</p>
            </b-card-body>
            <template v-slot:footer>
              <div v-if="subscriptionUser.subscription.priceName == 'StandardYearly'">Your Current Plan</div>
              <b-button variant="primary" v-if="subscriptionUser.subscription.priceName != 'StandardYearly'">Switch to Yearly Subscription</b-button>
            </template>
          </b-card>
        </b-card-group>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import AuthMixin from '../Mixins/AuthMixin.vue';
import SubscriptionMixin from '../Mixins/SubscriptionMixin.vue';
import axios from "axios";

export default {
  name: "SubscriberManageSubscription",
  mixins: [AuthMixin, SubscriptionMixin],
  props: {},
  data() {
    return {
      subscriptionUser: null,
      stripeSubscriptionDetails: null,
      inactiveSubscription: false,
      isResuming: false,
      resumeError: null,
    }
  },
  computed: {
    // True when the customer has canceled but the subscription is still active until the end of the billing period
    isCancellationScheduled: function () {
      return !!(this.stripeSubscriptionDetails
        && this.stripeSubscriptionDetails.cancelAtPeriodEnd
        && this.subscriptionUser
        && this.subscriptionUser.subscription.stripeStatus != 'canceled');
    }
  },
  methods: {
    // e.g. "25 November 2026" (falls back to the raw value if it can't be parsed)
    formatDate: function (value) {
      if (!value)
        return '';
      var date = new Date(value);
      return isNaN(date.getTime())
        ? value
        : date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
    },
    // Undo a scheduled cancellation (POST /api/subscription/resume), then reload the page data
    resumeSubscription: function () {
      this.isResuming = true;
      this.resumeError = null;

      axios({
        url: '/api/subscription/resume',
        method: 'POST',
        data: {
          subscriptionId: this.subscriptionUser.subscription.id
        }
      }).then(() => {
        this.loadSubscriptionUser();
      }).catch((error) => {
        var data = error && error.response && error.response.data;
        var details = data && (data.Details || data.details);
        this.resumeError = details || 'We could not resume your subscription. Please contact support.';
      }).then(() => {
        this.isResuming = false;
      });
    },
    cancelSubscription: function () {
      axios({
        url: '/api/subscription/cancel',
        method: 'POST',
        data: {
          subscriptionId: this.subscriptionUser.subscription.id
        }
      }).then((response) => {
        console.log(response);

        this.loadSubscriptionUser();
      });

    },
    loadSubscriptionUser: function () {
      axios({
        url: '/api/subscriptionUser?includes=subscription&filter=' + encodeURIComponent('applicationUserId="' + this.$root.$data.authenticatedUser.id + '"'),
        method: 'GET'
      }).then((response) => {
        if (!response.data || response.data.length < 1) {
          this.subscriptionUser = null;
          this.inactiveSubscription = true;
        } else {
          this.subscriptionUser = response.data[0];
          this.inactiveSubscription = !this.subscriptionUser.subscription.isActive;

          axios({
            url: '/api/subscription/' + this.subscriptionUser.subscription.id + '/stripeDetails',
            method: 'GET'
          }).then((response) => {
            this.stripeSubscriptionDetails = response.data;
          });
        }
      });

    }
  },
  watch: {
  },
  created() {
    this.loadSubscriptionUser();
  },
  async mounted () {
  }
};
</script>